import { render, staticRenderFns } from "./pointResUsage.vue?vue&type=template&id=784d1c1c&scoped=true&"
import script from "./pointResUsage.vue?vue&type=script&lang=js&"
export * from "./pointResUsage.vue?vue&type=script&lang=js&"
import style0 from "./pointResUsage.vue?vue&type=style&index=0&id=784d1c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d1c1c",
  null
  
)

export default component.exports